import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Range } from 'types';

import AvailableRangesTableRow from './AvailableRangesViewExpandedTableRow';
import { useAvailableRangesView } from '../context/AvailableRangesViewContext';

const AvailableRangesViewExpandedTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useAvailableRangesView();

  const hasData = data.availableRanges?.length > 0;

  return (
    <tbody>
      {hasData ? (
        <tr>
          {data.availableRanges.map((range: Range, index: number) => (
            <AvailableRangesTableRow
              // eslint-disable-next-line react/no-array-index-key
              key={`available-range-${index}`}
              range={range}
            />
          ))}
        </tr>
      ) : (
        <span className="sub-text text-danger">
          <i>{t('NoRangesAvailable')}</i>
        </span>
      )}
    </tbody>
  );
};

export default AvailableRangesViewExpandedTableBody;
